import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConstants} from '../shared/app.constants';
import {AuthService} from '../auth.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class CandidateService {

  constructor(private auth: AuthService, private appConstants: AppConstants, private http: HttpClient) {
  }

  getAllCandidates(): Observable<any> {
    const url = environment.apiBase + 'candidates';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getCandidate(candidateId): Observable<any> {
    const url = environment.apiBase + `candidates/${candidateId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  deleteCandidate(candidateId): Observable<any> {
    const url = environment.apiBase + `candidates/${candidateId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.delete(url, {headers}).map(response => response).catch(this.appConstants.errorHandler);
  }
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/candidates/candidate.service.ts